import React from 'react';
import { cn } from '../../lib/utils';

interface CounterProps {
  count: number;
  label?: string;
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Counter: React.FC<CounterProps> = ({
  count,
  label,
  variant = 'default',
  size = 'md',
  className,
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-primary-100 text-primary-800 border-primary-200 dark:bg-primary-900/30 dark:text-primary-300 dark:border-primary-800';
      case 'success':
        return 'bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800';
      case 'warning':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-800';
      case 'info':
        return 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-900/30 dark:text-gray-300 dark:border-gray-700';
    }
  };

  const getSizeStyles = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-base';
      default:
        return 'px-3 py-1.5 text-sm';
    }
  };

  return (
    <div className={cn(
      'inline-flex items-center gap-2 rounded-full border font-medium transition-all duration-200 hover:scale-105',
      getVariantStyles(),
      getSizeStyles(),
      className
    )}>
      <span className="font-bold tabular-nums">
        {count.toLocaleString('fr-FR')}
      </span>
      {label && (
        <span className="font-normal">
          {label}
        </span>
      )}
    </div>
  );
};